var blogs = {
    applyFilter: function( $this ) {
        var $p = $( '.blog-filters' ).closest( '.blogs-list-container' ).find( '.partial' );
        if ( $p.data( 'category_type' ) !== $this.data( 'value' ) ) {
            $( '.blog-filters a.nav-item' ).removeClass( 'active' );
            $this.addClass( 'active' );

            $p.data( 'category_type', $this.data( 'value' ) );
            $p.data( 'page', '1' );
            load_partial( $p );
        }

    }
};